import axiosInstance from "../../utils/axiosInstance";

class RoleService {
  private readonly baseURL = "/roles";

  async getRoles() {
    try {
      const response = await axiosInstance.get(this.baseURL);
      return response.data.map((role: any) => ({
        id: role.id,
        name: role.name,
      }));
    } catch (error) {
      console.error("Error fetching roles:", error);
      throw error; // Rethrow the error for further handling
    }
  }
}

export default new RoleService();
